export enum MessagesType {
  MESSAGES = 'messages',
  BULKS = 'bulks',
  FILES = 'files',
  BATCHES = 'batches',
}
